module.exports = __webpack_public_path__ + "img/Nantes.90f093aa.png";